var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-carousel",
    {
      ref: "carousel",
      attrs: {
        loop: _vm.customConfig.loop,
        height: _vm.customConfig.height,
        autoplay: _vm.customConfig.autoplay,
        trigger: _vm.customConfig.trigger,
        arrow: _vm.customConfig.arrow,
        "indicator-position": _vm.customConfig.indicatorPosition
      },
      on: { change: _vm.changePdf }
    },
    _vm._l(_vm.documentosBytes, function(documento) {
      return documento.bytes
        ? _c(
            "el-carousel-item",
            { key: documento.id },
            [
              documento.bytes && documento.id === _vm.documentoAtual.id
                ? _c("app-pdf-viewer", {
                    key: "pdf-" + documento.id,
                    attrs: { bytes: documento.bytes }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1731aafc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1731aafc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppPDFSlider.vue
// module id = null
// module chunks = 